import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { ContextWrapper } from "../../Context";
import { Route } from "react-router";
import RequestList from "./requests/RequestList";
import RequestDetails from "./requests/RequestDetails";
import RequestMain from "./requests/RequestMain";
import RequestRejection from "./RequestRejection";
import Handover from "./Handover";
import Takeover from "./Takeover";

class Index extends Component <RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <ContextWrapper>
			<Route path={ `${ pp }/handover_form` } exact={ true } component={ Handover }/>
			<Route path={ `${ pp }/takeover_form` } exact={ true } component={ Takeover }/>
			<Route path={ `${ pp }/requests` } exact={ true } component={ RequestMain }/>
			<Route path={ `${ pp }/requests/:roleId` } component={ RequestList }/>
			<Route
				path={ `${ pp }/request/:roleId/:reqType/:reqNo` } exact={ true }
				component={ RequestDetails }/>
			<Route
				path={ `${ pp }/request/reject/:reqNo` } exact={ true }
				component={ RequestRejection }/>
		</ContextWrapper>;
	}
}

export default Index;
